$(document).ready(function(){

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('html, body').animate({scrollTop: 0}, 'fast');
		$('body').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- Close mobile menu when click
	$('.header__menus li a:not(.dropdown-toggle)').on('click', function(){
		$('body').removeClass('mainMenu--open');
		$('.hamburger').removeClass('is-active');
	});

	// -- Close when click outside header --
	$(document).mouseup(function(e){
	  var container = $('.header');
    if (!container.is(e.target) && container.has(e.target).length === 0){
    	$('body').removeClass('mainMenu--open');
    	$('.hamburger').removeClass('is-active');
    }
	});

	
	$(document).on('scroll resize orientationchange', function(){
		// -- Vars --
		var scrollTop = $(this).scrollTop();
		var header = $('.header').outerHeight();

		// -- Header fixed --
		if (scrollTop > header) {
			$('body').addClass('header--fixed');
		} else {
			$('body').removeClass('header--fixed');
		}
	
		// -- active menu --
		onScroll();
	});
	
});

function onScroll(event){
  var scrollPos = $(document).scrollTop() + $('.header').outerHeight();
  $('.mainMenu a').each(function() {
    var currLink = $(this);
    var refElement = $(currLink.attr('href'));
    if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
      $('.mainMenu ul li a').removeClass('active');
      currLink.addClass('active');
    } else {
      currLink.removeClass('active');
    }
  });
}